// src/components/ChatBot.jsx
import React, { useState } from 'react';
import './ChatBot.css';
import { SendHorizonal } from 'lucide-react';

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: '¡Hola! ¿En qué puedo ayudarte hoy?' }
  ]);
  const [userInput, setUserInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);


  const toggleChat = () => setIsOpen(!isOpen);

  const handleSend = async () => {
  if (!userInput.trim()) return;

  const newMessages = [...messages, { from: 'user', text: userInput }];
  setMessages(newMessages);
  setUserInput(''); // <-- limpiar el input inmediatamente
  setIsLoading(true);

  try {
    const response = await fetch("https://chatwithopenrouter-gimkn5c4xa-uc.a.run.app", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ messages: newMessages })
    });

    const data = await response.json();
    const reply = data.reply || "Lo siento, algo salió mal.";
    setMessages([...newMessages, { from: 'bot', text: reply }]);
  } catch (error) {
    setMessages([...newMessages, { from: 'bot', text: "Error al conectar con el bot." }]);
  }

  setIsLoading(false);
};


  return (
    <div className="chatbot-container">
      <div className="chat-tab" onClick={toggleChat}>
        💬
      </div>

      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">Asistente Virtual</div>
          <div className="chat-body">
            {messages.map((msg, index) => (
              <div key={index} className={`chat-message ${msg.from}`}>
                {msg.text}
              </div>
            ))}

            {isLoading && (
              <div className="chat-message bot loading">Escribiendo...</div>
            )}
          </div>

          <div className="chat-input">
            <input
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Escribí tu mensaje..."
            />
            <button onClick={handleSend}><SendHorizonal size={16} /></button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;


